module.exports = __webpack_public_path__ + "media/images/flags/1x1/lbr-acfbd76a8f72c75ea86c4bcf9235a483.svg";